/** @module csi/widget/DndSource */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dnd/autoscroll",
	"dojo/dnd/common",
	"dojo/dnd/Manager",
	"dojo/dnd/Source",
	"dojo/dom-class",
	"dojo/dom-geometry",
	"dojo/has",
	"dojo/on",
	"dojo/query",
	"dojo/topic",
	"dojo/touch",
	"underscore",
	"csi/html",
	"csi/state"
], function(declare, lang, autoscroll, dnd, Manager, Source, domClass, domGeometry, has, on, query, topic, touch, _, html, state) {

	var CSS_ITEM = "csi-dnd-item-in-progress";
	var CSS_OVER = "csi-dnd-dragging-over";
	var CSS_OVER_NONE = "csi-dnd-dragging-over-none";

	function _dragOver(node) {
		domClass.add(node, CSS_OVER);
	}

	function _dragOut(node) {
		domClass.remove(node, CSS_OVER);
		domClass.remove(node, CSS_OVER_NONE);
	}

	function _startDnd(nodes) {
		nodes.addClass(CSS_ITEM);
	}

	topic.subscribe("/dnd/cancel", function() {
		// DOJO INTERNAL: this fixes a problem with Dojo that the dojoDndItemAnchor is not removed when item is dropped outside source
		query(".dojoDndItemAnchor").removeClass("dojoDndItemAnchor");
	});

	var _moveTimer;

	function _autoscrollOnHover(manager, e) {
		autoscroll.autoScrollNodes(e);

		setTimeout(function() {
			if (!_moveTimer && manager.avatar) {
				_autoscrollOnHover(manager, e);
			}
		}, 20);
	}

	lang.extend(Manager, {
		/**
		 * Override to change autoscroll behavior from being onMouseMove to on hover
		 * @param {Event} e
		 */
		onMouseMove: function(e) {
			// DOJO INTERNAL
			var a = this.avatar;
			if (a) {
				// CSI - do not autoscroll on mouse move - instead do so on hover
				//autoscroll.autoScrollNodes(e);
				var self = this;

				if (_moveTimer) {
					clearTimeout(_moveTimer);
				}

				_moveTimer = setTimeout(function() {
					_moveTimer = null;
					_autoscrollOnHover(self, e);
				}, 200);
				// CSI - END

				var s = a.node.style;
				s.top = (e.pageY + this.OFFSET_Y) + "px";
				s.left = (e.pageX + this.OFFSET_X) + "px";
				var copy = Boolean(this.source.copyState(dnd.getCopyKeyState(e)));
				if (this.copy != copy) {
					this._setCopyStatus(copy);
				}

			}

			if (has("touch")) {
				// Prevent page from scrolling so that user can drag instead.
				e.preventDefault();
			}
		}
	});

	return declare(Source, {
		/** @property {string} exemptTargetTag - disregard tag when starting a drag operation */
		exemptTargetTag: null,

		/** @property {boolean} enableDragDropOnMove - enable new technique to determine whether dragging item over the source using mouse move event */
		enableDragDropOnMove: false,

		/** @property {boolean} enableDropOverNone - allow drop at end when over source but not an individual item */
		enableDropOverNone: false,

		/** @property {DOMNode[]} [scrollParents] - if enableDragDropOnMove is true, and the source can be scrolled out of view, then provide list of nodes that can scroll */
		scrollParents: null,

		/** @property {boolean} _sourceAcceptable - set to false to disallow dropping onto the source */
		_sourceAcceptable: true,

		/** @property {boolean} _sourceOver - if enableDragDropOnMove is true, indicates if currently over source */
		_sourceOver: false,

		/** @property {boolean} dropInFront - if dropInFront is true, all dropped items will be moved to first position in container */
		dropInFront: false,

		/** @property {evt} _mouseEvent to store the mouse event so "before" can be calculated for rows with rowSpans */
		_mouseEvent: null,

		constructor: function(node, params) {
			if (this.enableDragDropOnMove) {
				this.events.push(
					on(document, touch.move, lang.hitch(this, "onMouseMove"))
				);
			}
		},

		/**
		 * Extension point to prevent dropping avatar
		 * @param {DomNode} source
		 * @param {Boolean} before
		 * @param {Event} [evt]
		 */
		allowDropping: function(before, source, evt) {
			return before;
		},

		/**
		 * @override
		 * Return false if source is not allowing drops
		 */
		checkAcceptance(source, nodes) {
			return this._sourceAcceptable && this.inherited(arguments);
		},

		cleanupDnd: function() {
			//summary: extension point to cleanup operations after canceling or dropping avatar
		},

		enableDndItem: function() {
			// summary: default fall-back function for enabling and disabling dnd
			return true;
		},

		insertNodes: function(addSelected, data, before, anchor) {
			if (this.dropInFront) {
				before = true;
				if (anchor) {
					anchor = anchor.parentNode.children[0];
				}
			}
			this.inherited(arguments, [addSelected, data, before, anchor]);
		},

		selectNode: function( /*DOMNode*/ node) {
			// summary: supplement Source with ability to add selected node
			var id = node.getAttribute("id");
			if (id) {
				this._addItemClass(node, "Selected");
				this.selection[id] = 1;
			}
		},

		stopDnd: function(node) {
			query("." + CSS_ITEM, node).removeClass(CSS_ITEM);
			this.cleanupDnd();
		},

		/**
		 * Remove drag styling when canceled
		 */
		onDndCancel: function() {
			_dragOut(this.node);
			this.stopDnd(this.node);
			this.onDndCancelExtension(this);
			state.set("dndInProgress", false);
			this._sourceOver = false;
			this.inherited(arguments);
		},

		/**
		 * Add drag styling when starting to drag
		 */
		onDndStart: function(source, nodes, copy) {
			this.inherited(arguments);
			_startDnd(nodes);
			if (this == source) {
				this.onDraggingOver();
				this.onDndStartExtension(this);
			}
			state.set("dndInProgress", true);
		},

		/**
		 * Extension point for when starting the DnD operation
		 * @param {DndSource} source
		*/
		onDndStartExtension(source) { },

		/**
		 * Extension point for when cancelling the DnD operation
		 * @param {DndSource} source
		 */
		onDndCancelExtension(source) { },

		/**
		 * Extension point for when dropping the avatar on the source
		 * @param {Object} source - source
		 * @param {Array} nodes - the selected DOM nodes
		 * @return {boolean} - return false if drop should be cancelled
		*/
		onDndDropExtension: function(source, nodes) {
			return true;
		},

		/**
		 * Extension point for when dragging the avatar 
		 * @param {Object} source
		 */
		onDndDragExtension: function(source) { },

		/**
		 * Extension point for processing selections
		 * @param {DndSource} source
		 * @param {Event} e - event object
		 */
		onDndSelectExtension: function(source, e) { },

		/**
		 * Extension point for mouse over event
		 * @param {Event} e - event object
		 */
		onMouseOverExtension: function(e) { },

		/**
		 * Extension point for mouse up event
		 * @param {DndSource} source
		 * @param {Event} e - event object
		 */
		onDndMouseUpExtension: function(source, e) { },

		/**
		 * Add CSS class when dragging over the source
		 */
		onDraggingOver: function() {
			_dragOver(this.node);
		},

		/**
		 * Remove CSS class when no longer dragging over the source
		 */
		onDraggingOut: function() {
			_dragOut(this.node);
		},

		/**
		 * Replace onMouseOver functionality with onMouseMove to prevent false out events when moving the mouse over the avatar
		 * @param {Event} e
		 */
		onMouseOver: function(e) {
			if (!this.enableDragDropOnMove) {
				this.inherited(arguments);
			}
			this.onMouseOverExtension(e);
		},

		/**
		 * Replace onMouseOver functionality with onMouseMove to prevent false out events when moving the mouse over the avatar
		 * @param {Event} e
		 */
		onMouseOut: function(e) {
			if (!this.enableDragDropOnMove) {
				this.inherited(arguments);
			}
		},

		/**
		 * Implement onMouseOver/onMouseOut functionality using onMouseMove to prevent false out events when moving the mouse over the avatar
		 * @param {Event} e
		 */
		onMouseMove: function(e) {
			this._mouseEvent = e;

			if (this.enableDragDropOnMove) {
				let over = html.mouseInNode(e.pageX, e.pageY, this.node, e);

				if (over && this.scrollParents) {
					over = _.every(this.scrollParents, function(domNode) {
						return html.mouseInNode(e.pageX, e.pageY, domNode);
					});
				}

				if (over && !this._sourceOver) {
					this._sourceOver = true;
					Source.prototype.onMouseOver.call(this, e);
				} else if (!over && this._sourceOver) {
					this._sourceOver = false;
					Source.prototype.onMouseOut.call(this, e);
				}

				// only call base class functionality when over source
				if (!this._sourceOver) {
					return;
				}
			}

			if (this.current) {
				this.onDndDragExtension(this, e);
			}

			this.inherited(arguments);

			// add class to source indicating if we are over the source, but not over any item
			if (this.node) {
				domClass.toggle(this.node, CSS_OVER_NONE, this.isDragging && !this.current);
			}
		},

		/**
		 * Remove drag styling when dropped
		 * @param {DndSource} source
		 * @param {DOMNode[]} nodes
		 */
		onDrop: function(source, nodes) {
			// drop at end of source if not over any items
			if (this.enableDropOverNone && !this.current && domClass.contains(this.node, CSS_OVER_NONE)) {
				this.before = false;
				this.current = this.node.lastChild;
			}

			if (this.onDndDropExtension(source, nodes)) {
				state.set("dndInProgress", false);
				this.stopDnd(this.node);
				_dragOut(this.node);
				this._sourceOver = false;
				this.inherited(arguments);
			} else {
				this.onDndCancel();
			}
		},

		/**
		 * This is to allow dragging of links to the address-bar or new tabs
		 * @param {event} e
		 */
		onSelectStart: function(e) {
			if (e.target.nodeName == this.exemptTargetTag) {
				return false;
			}

			this.inherited(arguments);
		},

		/**
		 * Add extension for disabling and enabling drag and drop
		 * @param {event} e
		 */
		onMouseDown: function(e) {
			if (this.enableDndItem()) {
				this.inherited(arguments);
			}

			this.onDndSelectExtension(this, e);
		},

		/**
		 * Add extension for mouse up event
		 * @param {event} e
		 */
		onMouseUp: function(e) {
			this.inherited(arguments);
			this.onDndMouseUpExtension(this, e);
		},

		/**
		 * Set target state of source to be valid for drop or disallow drop
		 * @param {boolean} valid 
		 */
		setTargetState(valid) {
			// reference: Source#onDndStart
			this._sourceAcceptable = valid;
			this._changeState("Target", valid ? "" : "Disabled");
		},

		/**
		 * Extension point to override _markTargetAnchor
		 * @param {Boolean} before
		 */
		_markTargetAnchor: function(before) {
			const {current} = this;
			const {targetBefore, targetNode} = this.allowDropping(before, this, this._mouseEvent);

			this.current = targetNode;
			this.inherited(arguments, [targetBefore]);
			this.current = current;
		}
	});
});